import { Component, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { CrudForm } from "src/app/components/shared/cruds/crud.form";
import { TiposUnidadDTO } from "src/app/models/tipo-unidad.dto";

@Component({
  selector: "app-form-drawer-tipo-unidad",
  templateUrl: "./drawer-form.component.html",
})
export class TipoUnidadDrawerForm
  extends CrudForm<TiposUnidadDTO>
  implements OnInit
{
  drawerRef: any;
  data?: {
    mode: "create" | "update";
    value: TiposUnidadDTO;
  };
  constructor(
    public fb: FormBuilder,
  ) {
    super(fb);
  }
  public ngOnInit(): void {
    this.buildForm();
    if (this.data) {
      this.defaults = this.data.value;
      if (this.data.mode === "update") {
        this.setUpdate(this.data.value);
      } else {
        this.setCreate();
      }
    }
  }

  // TODO add validators
    public fromInit(row: TiposUnidadDTO) {
      this.form.controls["IdTipoUnidad"].setValue(row?.IdTipoUnidad);
      this.form.controls["Descripcion"].patchValue(row?.Descripcion);
    }

    protected buildForm() {
      this.form = this.fb.group({
        IdTipoUnidad: [""],
        Descripcion: [""],
      });
    }

  public saveOver() {
    this.drawerRef.close({
      valid: this.form.invalid,
      data: {
        mode: this.mode,
        value: this.form.value,
      },
    });
  }

}
